<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">31.</span>
                    Within the last 5 years, have you or any employee of yours been subject to any complaint, disciplinary action or investigation by any regulatory authority?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="subjectToDisciplinaryAction"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.subjectToDisciplinaryAction"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="subjectToDisciplinaryAction"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.subjectToDisciplinaryAction"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('subjectToDisciplinaryAction')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('subjectToDisciplinaryAction') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.subjectToDisciplinaryAction == true || insuranceAgentApplication.subjectToDisciplinaryAction === 'true'">
                <label class="orep-label text-danger">If Yes, provide details
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="insuranceAgentApplication.subjectToDisciplinaryAction == true || insuranceAgentApplication.subjectToDisciplinaryAction === 'true'"
                    name="subjectToDisciplinaryActionDetails"
                    v-model="insuranceAgentApplication.subjectToDisciplinaryActionDetails"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">32.</span>
                    During the last five years have any claims or suits been made against the applicant or any of its predecessors in business, or any of the past or present directors, officers, solicitors, or employees?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="suitsAgaintsApplicantInLast5Years"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.suitsAgaintsApplicantInLast5Years"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="suitsAgaintsApplicantInLast5Years"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.suitsAgaintsApplicantInLast5Years"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('suitsAgaintsApplicantInLast5Years')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('suitsAgaintsApplicantInLast5Years') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.suitsAgaintsApplicantInLast5Years == true || insuranceAgentApplication.suitsAgaintsApplicantInLast5Years === 'true'">
                <label class="orep-label text-danger">If Yes, provide details
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="insuranceAgentApplication.suitsAgaintsApplicantInLast5Years == true || insuranceAgentApplication.suitsAgaintsApplicantInLast5Years === 'true'"
                    name="suitsAgaintsApplicantInLast5YearsDetails"
                    v-model="insuranceAgentApplication.suitsAgaintsApplicantInLast5YearsDetails"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">33.</span>
                    Are you, after inquiry of each person proposed for insurance, aware of any circumstance, error, omission, or offense that may result in a claim being made against the applicant or any of the applicant's employees?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="claimMadeAgainstApplicant"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.claimMadeAgainstApplicant"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="claimMadeAgainstApplicant"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.claimMadeAgainstApplicant"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('claimMadeAgainstApplicant')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('claimMadeAgainstApplicant') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.claimMadeAgainstApplicant == true || insuranceAgentApplication.claimMadeAgainstApplicant === 'true'">
                <label class="orep-label text-danger">If Yes, provide details
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="insuranceAgentApplication.claimMadeAgainstApplicant == true || insuranceAgentApplication.claimMadeAgainstApplicant === 'true'"
                    name="claimMadeAgainstApplicantDetails"
                    v-model="insuranceAgentApplication.claimMadeAgainstApplicantDetails"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </article>

            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">  COVERAGE REQUESTED </h1>
            </article>
            <article class="input-section form-section">
              <div class="row mb-3">
                <div class="col-md-8">
                  <label for class="orep-label mb-0 ml-1">
                    if your application for insurance is accepted what is the requested effective date?
                  </label>
                </div>
                <div class="col-md-4">
                  <datepicker
                      name="effectiveDate"
                      v-model="insuranceAgentApplication.effectiveDate"
                      format="MM/dd/yyyy"
                      input-class="orep-text-input-date"
                      @input="validateBeforeSubmit()"
                      v-validate="'required'"
                      :clearButton="false"
                      :value="computedDates"
                  ></datepicker>
                  <span
                      v-show="errors.has('effectiveDate')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('effectiveDate') | filterText }}</span>
                </div>

              </div>

              <label for class="orep-label">
                Each and Every claim and in the Aggregate?
              </label>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-one"
                      value="2M"
                      class="orep-radio"
                      :checked="insuranceAgentApplication.desiredCoverage.find(coverage => coverage === '2M')"
                      v-validate="'required|included:2M,1M,0.5M,0.3M,other'"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$2,000,000</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-two"
                      value="1M"
                      class="orep-radio"
                      :checked="insuranceAgentApplication.desiredCoverage.find(coverage => coverage === '1M')"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$1,000,000</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-three"
                      value="0.5M"
                      class="orep-radio"
                      :checked="insuranceAgentApplication.desiredCoverage.find(coverage => coverage === '0.5M')"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$500,000</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-four"
                      value="0.3M"
                      class="orep-radio"
                      :checked="insuranceAgentApplication.desiredCoverage.find(coverage => coverage === '0.3M')"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$300,000</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-other"
                      value="other"
                      class="orep-radio"
                      :checked="insuranceAgentApplication.desiredCoverage.find(coverage => coverage === 'other')"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">other</span>
                </label>
              </div>
              <span
                  v-show="errors.has('desiredCoverage')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('desiredCoverage') | filterText }}</span>
              <input
                  type="text"
                  class="orep-text-input"
                  name="desiredCoverageCustomLimit"
                  placeholder="Request a different Limit:"
                  v-if="insuranceAgentApplication.desiredCoverage.find(coverage => coverage === 'other')"
                  v-model="insuranceAgentApplication.desiredCoverageCustomLimit"
                  @input="validateBeforeSubmit()"
              >
              <div class="row mb-3">
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
              <label for class="orep-label">
                What deductible are you requesting?
              </label>
              <div class="d-flex flex-row align-items-center row px-3">
                <label class="orep-label col-md-3 mb-0">
                  <span class="mr-2"></span>
                  Select Deductible:
                </label>
                <select
                    class="orep-select col-md-3 w-100"
                    name="deductible"
                    v-model="insuranceAgentApplication.deductible"
                    v-validate="'required'"
                >
                  <option value="2500">$2,500</option>
                  <option value="5000">$5,000</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <span
                  v-show="errors.has('deductible')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('deductible') | filterText }}</span>
                </div>
              </div>

              <div v-if="insuranceAgentApplication.deductible === 'other'" class="row mb-3">
                  <div class="col-md-8">
                <input
                    type="text"
                    class="orep-text-input"
                    name="deductibleCustomLimit"
                    placeholder="Other Deductible:"
                    v-if="insuranceAgentApplication.deductible === 'other'"
                    v-model="insuranceAgentApplication.deductibleCustomLimit"
                    @input="validateBeforeSubmit()"/>
                  </div>
              </div>

            </article>

          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'ibdpro-insurance-agent-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button class="pagination-dots" @click="navigateToOne()"></button>
            <button class="pagination-dots" @click="navigateToPrev('ibdpro-insurance-agent-application-2')"></button>
            <button class="pagination-dots" @click="navigateToPrev('ibdpro-insurance-agent-application-3')" :disabled="!state.pageThreeIsValid"></button>
            <span class="pagination-dots pagination-current"></span>
            <button class="pagination-dots" @click="navigateToNext('ibdpro-insurance-agent-application-5')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid"></button>
            <button
                class="pagination-dots"
                :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid|| !state.pageFiveIsValid"
                @click="navigateToNext('ibdpro-insurance-agent-application-6')">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageFourIsValid"
            :class="{submitDisabled: !state.pageFourIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('ibdpro-insurance-agent-application-5')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";

var moment = require('moment')
export default {
  name: "ibdpro-insurance-agent-application-4",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    insuranceAgentApplication() {
      return this.$store.state.insuranceAgentApplication.insuranceAgentApplication;
    },
    state() {
      return this.$store.state.insuranceAgentApplication;
    },
    errorMsg() {
      return this.$store.state.insuranceAgentApplication.errorMsg;
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.insuranceAgentApplication.desiredCoverage.find(coverage => coverage === event.target.value)) {
        if (this.insuranceAgentApplication.desiredCoverage.length < 1) {
          this.insuranceAgentApplication.desiredCoverage.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 1 coverages.'
          });
          event.target.checked = false
        }
      } else {
        this.insuranceAgentApplication.desiredCoverage = this.insuranceAgentApplication.desiredCoverage.filter(coverage => coverage !== event.target.value);
      }
    },
    navigateToOne() {
      this.$router.push({
        name: "ibdpro-insurance-agent-application-1"
      });
    },

    navigateToPrev(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFourIsValid = true;
          return;
        }
        this.state.pageFourIsValid = false;
      });
    }
  },

  mounted() {
    this.validateBeforeSubmit();
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td, table th {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
